import { colors, textSizes, weights } from '@components/theme/styles/index';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, styled } from '@mui/material';
import { rem } from 'polished';

interface AccentColorStyleProps {
  accentcolor?: string;
}

export const ErrorLayout = styled(Box)({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100vw',
  height: '100vh',
  backgroundColor: colors.grayLight2,
});

export const Container = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: colors.white,
  width: rem(600),
  padding: rem(80),
  borderRadius: rem(10),
  fontSize: textSizes.lg,
  filter: `drop-shadow(0 ${rem(4)} ${rem(3)} rgb(0 0 0 / 0.07)) drop-shadow(0 ${rem(2)} ${rem(2)} rgb(0 0 0 / 0.06))`,

  [theme.breakpoints.down('sm')]: {
    width: '80%',
    padding: rem(30),
    fontSize: textSizes.base,
  },
}));

export const HeaderBox = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  textAlign: 'center',
  gap: rem(16),
});

export const ErrorIcon = styled(FontAwesomeIcon)<AccentColorStyleProps>(
  ({ accentcolor, theme }) => ({
    fontSize: rem(50),
    color: accentcolor ?? colors.danger,

    [theme.breakpoints.down('sm')]: {
      fontSize: rem(40),
    },
  }),
);

export const HeaderText = styled('p')(
  ({ theme }) =>
    ({
      fontSize: rem(20),
      fontWeight: weights.semiBold,
      [theme.breakpoints.down('sm')]: {
        fontSize: textSizes.xl,
      },
    }) as any,
);
